import { Outlet } from 'react-router-dom'
import CookieBanner from '../ui/CookieBanner'

export default function PublicLayout() {
  return (
    <div className="min-h-screen">
      <Outlet />
      <CookieBanner />
    </div>
  )
}
